import type React from 'react';
import type { Spec, ElementContext } from 'axe-core';

export const reportAccessibility = async (
  App: typeof React,
  config?: Spec,
  context?: ElementContext,
): Promise<void> => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line
    const axe = await import('@axe-core/react');
    const ReactDOM = await import('react-dom');

    axe.default(App, ReactDOM, 1000, config, context);
  }
};

export default reportAccessibility;
